import { Dialog, Grow } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { DialogStore } from '.'

const DialogBase = observer(({ store }: { store: DialogStore }) => {
  const DialogContent = store.DialogComponent

  if (store.isCustom && DialogContent) {
    return <DialogContent {...store.props} open={store.opened} onClose={store.close}/>
  }

  return (
    <Dialog
      open={store.opened}
      onClose={store.close}
      TransitionComponent={Grow}
      PaperProps={{ sx: { overflow: 'visible' } }}
      maxWidth='md'
    >
      { DialogContent && <DialogContent {...store.props} open={store.opened} />}
      
    </Dialog>
  )
})

export default DialogBase
